import React from 'react';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import Label from '../../FormElements/Label';
import Switch from '../../FormElements/Switch';
import FormSection from '../../FormElements/FormSection';
import FormSubmit from '../../FormElements/FormSubmit';
import LoaderOverlay from '../../LoaderOverlay/LoaderOverlay';

export default class EditUserLearningPlanExamsDataForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			first_name: '',
			last_name: '',
			email_address: '',
			branch: '',
			roles: [],
			is_reportable: null,
			globalErrors: [],
			fieldErrors: {}
		};

		this.onChange = this.onChange.bind(this);
		this.onSetFieldError = this.onSetFieldError.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		console.log('About to load data...');
		if (this.props.iam_get_user_profile_endpoint) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps) {
		// console.log('prevProps', prevProps);
		if (
			prevProps.iam_get_user_profile_endpoint !==
			this.props.iam_get_user_profile_endpoint
		) {
			// console.log('About to reload data...');
			this.loadData();
		}
	}

	render() {
		// console.log(
		// 	'Edit User Profile Form - Props',
		// 	this.props,
		// 	'Edit User Profile Form - State',
		// 	this.state
		// );

		return (
			<div className="FormElements">
				<form onSubmit={this.onSubmit}>
					<FormSection>
						<GlobalErrorsBox globalErrors={this.state.globalErrors} />
						<div className="my-3">
							<Label>Personal Finance Learning Plan Exam</Label>
							<Switch
								isOn={this.state.is_reportable}
								handleToggle={() => {
									this.props.onChange({
										target: {
											name: 'is_reportable',
											value: true
										}
									});
								}}
							/>
						</div>
						<div className="my-3">
							<Label>Buying a Home Learning Plan Exam</Label>
							<Switch
								isOn={this.state.is_reportable}
								handleToggle={() => {
									this.props.onChange({
										target: {
											name: 'is_reportable',
											value: !true
										}
									});
								}}
							/>
						</div>
						<div className="my-3">
							<Label>Stocks & Bonds Learning Plan Exam</Label>
							<Switch
								isOn={this.state.is_reportable}
								handleToggle={() => {
									this.props.onChange({
										target: {
											name: 'is_reportable',
											value: !true
										}
									});
								}}
							/>
						</div>
						<div className="my-3">
							<Label>Credit Cards Learning Plan Exam</Label>
							<Switch
								isOn={this.state.is_reportable}
								handleToggle={() => {
									this.props.onChange({
										target: {
											name: 'is_reportable',
											value: !true
										}
									});
								}}
							/>
						</div>
						<div className="my-3">
							<Label>Crypto Currency Learning Plan Exam</Label>
							<Switch
								isOn={this.state.is_reportable}
								handleToggle={() => {
									this.props.onChange({
										target: {
											name: 'is_reportable',
											value: !true
										}
									});
								}}
							/>
						</div>
					</FormSection>
					<FormSubmit
						text={I18n.t(
							'admin.user_profile.update_user_profile_submit_button'
						)}
					/>
				</form>
				{this.state.loading ? <LoaderOverlay /> : null}
			</div>
		);
	}

	styleTextInputOnError(fieldName) {
		if (this.state.fieldErrors) {
			if (fieldName in this.state.fieldErrors) {
				return { border: '1px solid #ff3d60', borderRadius: '5px' };
			}
		}
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSetFieldError(errorsArray, error) {
		if (errorsArray.includes(error)) {
			return 'Error';
		}
	}

	onSubmit(e) {
		// console.log(
		// 	'Editing User Profile..',
		// 	this.props.update_user_profile_endpoint
		// );
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			loading: true
		});

		$.ajax({
			type: 'POST',
			url: this.props.lock_unlock_exam_endpoint,
			data: {
				//
			},
			dataType: 'json'
		}).done((data) => {
			// console.log('Done!', data);
			if (data.success === true) {
				// console.log('User Profile updated!', data);
				this.setState({
					loading: false
				});
				this.props.onHidePopup();
				this.props.onShowSuccessCardPopup();
			} else if (data.status == 'session_expired') {
				// console.log('Session expired!');
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else {
				// console.log('User Profile update failed!');
				this.setState({
					loading: false,
					globalErrors: data.errors.global,
					fieldErrors: data.errors.fields
				});
			}
		});
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'GET',
			url: this.props.get_user_learning_plan_exams_endpoint
		}).done((payload) => {
			const result = payload;
			// console.log('User Profile data loaded!', result);
			this.setState({
				loading: false,
				first_name: 'Abe',
				last_name: 'Foreman',
				email_address: 'abe.frohman@example1.com',
				branch: 'Battlefield Blvd.',
				roles: [],
				is_reportable: true
			});
		});
	}
}
